function encodeStorefrontNodeId(type: string, id: string | number): string {
  const adminApiId = `gid://shopify/${type}/${id}`;
  const storeFrontId = btoa(adminApiId);

  return storeFrontId;
}

export default encodeStorefrontNodeId;
